// Called only by the mini-program product detail branch.
export async function loadMiniProductDetail(vm, loadProfile, commitProfile, hasSession = () => true) {
  const query = { ...vm.$route.query };
  const resume = query.miniPurchase === "1" && !vm._miniPurchaseHandled;
  const activityId = query.miniActivityId || null;
  if (resume) {
    vm._miniPurchaseHandled = true;
    delete query.miniPurchase;
    delete query.miniActivityId;
    await vm.$router.replace({ path: vm.$route.path, query, hash: vm.$route.hash });
  }
  let profile = {};
  try {
    const res = hasSession() ? await loadProfile() : null;
    if (res?.code === 1 && res.data?.user_id) profile = res.data;
  } catch (_) {
    // Still load the public detail when profile lookup fails.
  }
  if (vm._isDestroyed) return;
  if (resume && !profile.user_id) vm.$message.error("登录状态获取失败，请重新点击购买");
  commitProfile(profile);
  await vm.apiGetCourseInfo();
  if (vm._isDestroyed) return;
  if (resume && profile.user_id && vm.productInfo?.enrollment === null && vm.productInfo?.enrollment_state !== 3) {
    vm.signUp(activityId);
  }
}
